import { VerifyHybridTokenInput } from '../../gql/graphql';
import authService from '../../services/auth.service';

/**
 * Attempts to verify the supplied token
 * @param input - The token to verify
 * @returns - a boolean indaticating whether or not the token is valid
 */
const verifyHybridToken = async (input: VerifyHybridTokenInput) => {
  try {
    const { data, errors } = await authService.verifyHybridToken(input);

    if (errors) {
      // log error but don't throw/set it as if hybrid authentication fails, we don't want to block the user from continuing (bad UX),
      // they just need to re-authenticate through IDV (not great UX, but better than blocking)
      console.error(errors);
      return false;
    }

    if (data?.verifyHybridToken?.verifyHybridTokenErrors?.length) {
      // log error but don't throw/set it as if hybrid authentication fails, we don't want to block the user from continuing (bad UX),
      // they just need to re-authenticate through IDV (not great UX, but better than blocking)
      console.error(data.verifyHybridToken.verifyHybridTokenErrors);
      return false;
    }

    return true;
  } catch (e) {
    // log error but don't throw/set it as if hybrid authentication fails, we don't want to block the user from continuing (bad UX),
    // they just need to re-authenticate through IDV (not great UX, but better than blocking)
    console.error(e);
    return false;
  }
};

export default verifyHybridToken;
